import { Reducer } from "redux";
import { IEquipment } from "../../models/iequipment";
import { updateObject } from "../../utils/updateObject";
import * as actionTypes from '../actions/actionTypes';

export interface IEquipmentsPublicState {
  equipment: IEquipment,
  loading: boolean,
  error: string,
}

const initialState: IEquipmentsPublicState = {
  equipment: {} as IEquipment,
  loading: false,
  error: '',
};

const requestEquipmentsPublicStart = (state: IEquipmentsPublicState, action: any): IEquipmentsPublicState => {
  return updateObject(state, { loading: true });
};

const requestEquipmentsPublicFail = (state: IEquipmentsPublicState, action: any): IEquipmentsPublicState => {
  return updateObject(state, { loading: false, error: action.error });
};

const fetchEquipmentPublicByIdSuccess = (state: IEquipmentsPublicState, action: any) => {
  return updateObject(state, {
    equipment: action.equipment,
    error: '',
    loading: false
  });
}


const reducer: Reducer<IEquipmentsPublicState> = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.REQUEST_EQUIPMENTS_PUBLIC_START: return requestEquipmentsPublicStart(state, action);
    case actionTypes.REQUEST_EQUIPMENTS_PUBLIC_FAIL: return requestEquipmentsPublicFail(state, action);
    case actionTypes.FETCH_EQUIPMENTS_PUBLIC_BY_ID_SUCCESS: return fetchEquipmentPublicByIdSuccess(state, action);
    
    default: return state;
  }
};

export default reducer;